import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeptBranchJobService } from 'app/core/services/dept-branch-job.service';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { RefreshPeriodService } from 'app/core/services/refresh-period.service';
import { RefreshService } from 'app/core/services/refresh.service';
import { RefreshBranchService } from 'app/core/services/refresh/refresh-branch.service';
import { RefreshDepService } from 'app/core/services/refresh/refresh-dep.service';
import { RefreshJobService } from 'app/core/services/refresh/refresh-job.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'dialog-delete-depbranchjob',
  templateUrl: './dialog-delete-depbranchjob.component.html',
  styleUrls: ['./dialog-delete-depbranchjob.component.scss']
})
export class DialogDeleteDepbranchjobComponent implements OnInit {
  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteDepbranchjobComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private depBranchJobService: DeptBranchJobService,
    private refreshDepService: RefreshDepService,
    private refreshBranchService: RefreshBranchService,
    private refreshJobService: RefreshJobService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteDepartment() {
    this.isLoading = true;
    const form = {
      id: this.data.id,
      type: this.data.type
    };
    this.depBranchJobService.deleteDepBranchJob(form).subscribe({
      next: res => {
        this.isLoading = false;
        this.refreshDepService.emitRefresh(this.data.index);
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.showNotificationError("Something went wrong while deleting the department.");
        this.isLoading = false;
      }
    })
  }

  deleteBranch() {
    this.isLoading = true;
    const form = {
      id: this.data.id,
      type: this.data.type
    };
    this.depBranchJobService.deleteDepBranchJob(form).subscribe({
      next: res => {
        this.isLoading = false;
        this.refreshBranchService.emitRefresh(this.data.index);
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.showNotificationError("Something went wrong while deleting the branch.");
        this.isLoading = false;
      }
    })
  }

  deleteJob() {
    this.isLoading = true;
    const form = {
      id: this.data.id,
      type: this.data.type
    };
    this.depBranchJobService.deleteDepBranchJob(form).subscribe({
      next: res => {
        this.isLoading = false;
        this.refreshJobService.emitRefresh(this.data.index);
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.showNotificationError("Something went wrong while deleting the job.");
        this.isLoading = false;
      }
    })
  }

  showNotificationError(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-danger alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }
}
